<template>
	<div class="u-bg-color-white u-position--relative ph pt- pb- mb mt u-border">
		<div class="desk-mh-">
			<div class="layout">
				<div
					class="layout__item u-5/24-default default-pr default-pt- u-palm-text-align--center palm-pb-"
				>
					<img
						:alt="currentSupplierMessage.supplierName"
						class="u-1/3-palm c-comparison-list__provider-logo c-comparison-list__provider-logo--current u-display--inline-block"
						:src="currentSupplierMessage.supplierLogo"
						data-loaded="true"
					/>
				</div>
				<div class="layout__item u-19/24-default">
					<h5
						class="mb0 palm-default-font-size u-font-style--italic"
					>Zoekt u naar uw huidige leverancier?</h5>
					<div class="zeta">
						{{currentSupplierMessage.supplierName}}
						<span v-html="currentSupplierMessage.message" />.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		currentSupplierMessage: {
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style>
</style>
